import React from "react";
import {Typography} from "@material-ui/core";
import PropTypes from 'prop-types';
import dayjs from "dayjs";
import {useRecoilValue} from "recoil";
import {durationState, timeOutV2State} from "../../states/states";
import i18n from 'i18next';

const TestDuration = (props) => {
    const duration = useRecoilValue(durationState);
    const timeOutV2 = useRecoilValue(timeOutV2State);
    const startTime = props.startTime;
    const endTime = props.endTime;
    const align = props.align;
    let hourTestTime = (endTime !== null && startTime !== null) ? dayjs(endTime).diff(dayjs(startTime), 'hour') : 0;
    let minuteTestTime = (endTime !== null && startTime !== null) ? dayjs(endTime).diff(dayjs(startTime), 'minute') : 0;
    let secondTestTime = (endTime !== null && startTime !== null) ? dayjs(endTime).diff(dayjs(startTime), 'second') : 0;

    if (timeOutV2) {
        if (duration < 60) {
            return (
                <Typography variant="subtitle2" align={align}>
                    {i18n.t('time_worked')}:
                    00 {i18n.t('hours')} {duration < 10 && "0"}{duration} {i18n.t('minute')} 00 {i18n.t('second')}
                </Typography>

            );
        } else if (duration >= 60) {
            hourTestTime = 1;
            minuteTestTime = duration - 60;
            if (duration >= 120) {
                hourTestTime = 2;
                minuteTestTime = duration - 120;
                if (duration >= 180) {
                    hourTestTime = 2;
                    minuteTestTime = duration - 180;
                    if (duration >= 240) {
                        hourTestTime = Math.ceil(duration / 60);
                        minuteTestTime = 0;
                    }
                }
            }
            return (
                <Typography variant="subtitle2" align={align}>
                    {i18n.t('time_worked')}: {hourTestTime < 10 && "0"}{hourTestTime} {i18n.t('hours')} {minuteTestTime < 10 && "0"}{minuteTestTime} {i18n.t('minute')} 00 {i18n.t('second')}
                </Typography>
            )
        }
    }
    if (minuteTestTime >= 60) {
        minuteTestTime = Math.ceil(minuteTestTime / 60);
    }
    if (secondTestTime >= 60 && secondTestTime < 3600) {
        secondTestTime = Math.ceil(secondTestTime / 60);
    } else if (secondTestTime >= 3600) {
        secondTestTime = Math.ceil(secondTestTime / 3600)
    }

    return (
        <Typography variant="subtitle2" align={align}>
            {i18n.t('time_worked')}: {hourTestTime < 10 && "0"}{hourTestTime} {i18n.t('hours')} {minuteTestTime < 10 && "0"}{minuteTestTime} {i18n.t('minute')} {secondTestTime < 10 && "0"}{secondTestTime} {i18n.t('second')}
        </Typography>

    );
};

export default TestDuration;

TestDuration.propTypes = {
    children: PropTypes.node,
};
